import { httpCollection } from "us.helper/http/collection";

export default {
  file: {
    preview: <
      P extends {
        file: any;
        creditor: number;
        fileType: number;
        profileName: string;
      }
    >({
      file,
      creditor,
      fileType,
      profileName,
    }: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const formData = new FormData();
          formData.append("file", file[0]);

          const { data } = await httpCollection.post(
            "fileconverterservice",
            `creditors/${creditor}/file-types/${fileType}/mapping-profiles/${profileName}/preview`,
            formData
          );

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    import: <
      P extends {
        file: any;
        creditor: number;
        fileType: number;
        profileName: string;
      }
    >({
      file,
      creditor,
      fileType,
      profileName,
    }: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const formData = new FormData();
          formData.append("file", file[0]);

          const { data } = await httpCollection.post(
            "fileconverterservice",
            `creditors/${creditor}/file-types/${fileType}/mapping-profiles/${profileName}/upload`,
            formData
          );

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  profiles: {
    get: (): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data } = await httpCollection.get(
            "fileconverterservice",
            `creditors-with-mapping-profiles`,
            {}
          );

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
